<template>
    <div class="bg-white">
        <nav class="sub-menu border-b border-secondary">
            <router-link
                class="sub-menu-item"
                :to="{ name: 'VirtualGroupAdminVirtualGroups' }"
                @click.prevent.stop="gotoRoute({ name: 'VirtualGroupAdminVirtualGroups' })"
            >
                <IconCourseAlt class="w-6 h-6 mr-2" />
                {{ $t("Virtual Groups") }}</router-link
            >
        </nav>
    </div>
</template>
<script>
export default {
    methods: {
        gotoRoute(route) {
            this.$router.push(route);
            this.$store.commit("closeMobileMenu");
        }
    }
};
</script>

<style lang="postcss" scoped>
.sub-menu {
    @apply bg-secondary bg-opacity-25  px-0 sm:px-12 text-dark-grey text-sm flex flex-row flex-wrap items-center;
}
.sub-menu-item {
    @apply text-xs sm:text-base py-1 sm:py-2 px-4 sm:px-8 
    flex flex-row justify-start items-center flex-none w-full sm:w-auto;
}
.sub-menu-item:hover {
    @apply bg-secondary bg-opacity-75 text-white transition duration-500;
}
.sub-menu-item.router-link-active {
    @apply bg-secondary text-white transition duration-500;
}
</style>